import React from 'react'
import CategoriesHead from './Components/Categories/CategoriesHead'
import CategoriesBody from './Components/Categories/CategoriesBody'

const Categories = () => {
  return (
    <div>
      <CategoriesHead/>
      <CategoriesBody/>
    </div>
  )
}

export default Categories
